<template>
  <div class="page-wrapper">
    <div class="page-header"></div>
    <div class="page-body">
      <div class="sub-nav-section">
        <div class="instuctor-menus">
          <!-- menu list -->
          <div class="menus-widget">
            <ul class="menu-list">
              <li v-for="(menu, index) in menus_data" :key="index" @click="selectMenu(menu)">
                <a class="main-menu" :class="{ active: menu.name == selected_view }">
                  <span>
                    {{ menu.label }}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main-content-section">
        <InvitationToBuildProfile v-if="selected_view == 'invitation-to-build-profile'" @saveFilter="onSaveFilter"
          :formFilter="filter_form">
        </InvitationToBuildProfile>
        <StudentsCompanyInteraction v-if="selected_view == 'students-company-interaction'" @saveFilter="onSaveFilter"
          :formFilter="filter_form"></StudentsCompanyInteraction>
        <PeriodicReminders v-if="selected_view == 'periodic-reminders'" @saveFilter="onSaveFilter"
          :formFilter="filter_form"></PeriodicReminders>
        <ProfileUpdate v-if="selected_view == 'ratings-profile-updates'" @saveFilter="onSaveFilter"
          :formFilter="filter_form"></ProfileUpdate>
      </div>
    </div>
  </div>
</template>
<script>
import InvitationToBuildProfile from "@/views/Instructor/components/InvitationToBuildProfile.vue";
import StudentsCompanyInteraction from "@/views/Instructor/components/StudentsCompanyInteraction.vue";
import PeriodicReminders from "@/views/Instructor/components/PeriodicRemindersEvaluation.vue";
import ProfileUpdate from "@/views/Instructor/components/RatingProfileUpdate.vue";

export default {
  components: {
    InvitationToBuildProfile,
    StudentsCompanyInteraction,
    PeriodicReminders,
    ProfileUpdate,
  },
  data: () => ({
    menus_data: [
      {
        label: "Invitation to Build Profile",
        name: "invitation-to-build-profile",
        active: false,
      },
      {
        label: "Students & Company interaction",
        name: "students-company-interaction",
        active: false,
      },
      // {
      //   label: "Periodic reminders & Evaluation",
      //   name: "periodic-reminders",
      // },
      {
        label: "Ratings & Profile Update",
        name: "ratings-profile-updates",
        active: false,
      },
    ],
    footer_menus_data: [
      {
        label: "Notifications",
        name: "notifications",
        active: false,
      },
      {
        label: "Emails",
        name: "emails",
        active: false,
      },
      {
        label: "Questionnaire",
        name: "forms",
        active: false,
      },
    ],
    footer_menu_expanded: true,
    selected_view: "",
    filter_form: {
      class: null,
      id: null,
      id_type: "",
      sort_by: "all",
      query: "",
    }
  }),
  watch: {
    "$route.query.sub_menu"(val) {
      let vm = this;
      if (val) {
        vm.selected_view = val;
      } else {
        vm.selected_view = "invitation-to-build-profile";
      }
    },
  },
  mounted() { },
  created() {
    let vm = this;
    vm.initContent();
  },
  methods: {
    onSaveFilter(key, value) {
      let vm = this;
      vm.filter_form[key] = value;
    },
    initContent() {
      let vm = this;
      if (!vm.$route.query.sub_menu) {
        vm.selectMenu(vm.menus_data[0]);
      } else {
        let sub_menu = vm.menus_data.find(
          (item) => item.name == vm.$route.query.sub_menu
        );
        if (!sub_menu) {
          sub_menu = vm.footer_menus_data.find(
            (item) => item.name == vm.$route.query.sub_menu
          );
        }
        if (!sub_menu) {
          sub_menu = vm.menus_data[0];
        }
        vm.selectMenu(sub_menu);
      }
    },

    selectMenu(sub_menu) {
      let vm = this;
      vm.selected_view = sub_menu.name;
      vm.$router.push({
        name: "instructor",
        query: { sub_menu: sub_menu.name },
      });
    },
    toggleFooterMenu() {
      let vm = this;
      vm.footer_menu_expanded = !vm.footer_menu_expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f6f6f6;
  padding: 5px;
  position: relative;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    height: calc(100% - 43px);
    display: flex;
    justify-content: space-between;

    .sub-nav-section {
      width: 220px;
      height: max-content;
      background: #fff;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      padding: 20px 0px;

      .instuctor-menus {
        display: flex;
        flex-direction: column;
        height: calc(100% - 168px);
        overflow-y: auto;

        .menus-widget {
          ul.menu-list {
            list-style: none;
            padding-left: 12px;
            margin: 0px;

            li {
              .main-menu {
                text-decoration: none;
                padding: 10px 10px;
                display: flex;
                justify-content: space-between;
                cursor: pointer;
                border-left: 3px solid #eff1f8;
                position: relative;
                font-family: "Nunito";
                font-style: normal;
                font-weight: 400;
                color: #707070;

                &.active {
                  color: #1ba5a4;

                  &::after {
                    content: "";
                    position: absolute;
                    width: 5px;
                    height: 100%;
                    background: #1ba5a4;
                    bottom: 0px;
                    left: -4px;
                    border-radius: 14px;
                  }
                }

                &:hover {
                  color: #1ba5a4;
                }
              }
            }
          }
        }

        .footer-menus {
          padding: 0px 25px;

          .footer-header {
            border-top: 1px solid #ddd;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            color: #707070;
            cursor: pointer;
          }

          .footer-body {
            ul.menu-list {
              list-style: none;
              padding-left: 0px;
              margin: 0px;

              li {
                .main-menu {
                  text-decoration: none;
                  color: #707070;
                  padding: 10px 10px;
                  display: flex;
                  justify-content: space-between;
                  cursor: pointer;
                  border-left: 3px solid #eff1f8;
                  position: relative;

                  &.active {
                    color: #1ba5a4;

                    &::after {
                      content: "";
                      position: absolute;
                      width: 5px;
                      height: 100%;
                      background: #1ba5a4;
                      bottom: 0px;
                      left: -4px;
                      border-radius: 14px;
                    }
                  }

                  &:hover {
                    color: #1ba5a4;
                  }
                }
              }
            }
          }
        }
      }
    }

    .main-content-section {
      height: 100%;
      width: calc(100% - 225px);
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
